import { Instance, SnapshotOut, types, cast } from "mobx-state-tree"
import { BaseModelStoreProps } from "../base-model-store/base-model-store"
import { withEnvironment } from "../extensions/with-environment"
import { withRootStore } from "../extensions/with-root-store"
import { withBaseModel } from "../extensions/with-base-model"
import JalaAnalytic from "../../utils/jala-analytic"
import { getGeneralApiProblem } from "../../services/api/api-problem"

/**
 * Model description here for TypeScript hints.
 */
const CycleToDoStoreProps = {
  ...BaseModelStoreProps,

  refreshing: types.maybeNull(types.boolean),

  hiddenParameter: types.optional(types.array(types.frozen()), []),
  hiddenState: types.optional(types.array(types.frozen()), [])
}

export const CycleToDoStoreModel = types
  .model("CycleToDoStore")
  .props(CycleToDoStoreProps)
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withBaseModel)
  .views((self) => ({})) // eslint-disable-line @typescript-eslint/no-unused-vars
  .actions((self) => ({
    set(key: keyof typeof CycleToDoStoreProps, value: any) {
      if (self[key] === value) return
      self[key] = value as never;
    },
    init() {
      this.set('hiddenState', [])
      this.set('loading', false);
      this.set('refreshing', false);
    },
    async fetchActivity (params = {}) {
      const { tokenStore } = self.rootStore
      const accessToken = tokenStore.token.access_token
      const result: any = await self.apiSauce.get("/cycle_to_dos", params, {
        headers: {
          Authorization : `Bearer ${accessToken}`
        }
      })
      this.set('loading', false);
      if (result.status === 200) {
        const { data } = result.data;
        return data
      }
    },

    async updateFarm(body) {
      const { tokenStore: { token }, appStore: { farmStore: { farmId } } } = self.rootStore
      this.set('loading', true)
      const result: any = await self.apiSauce.put(`/farms/${farmId}`, body, {
        headers: {
          Authorization : `Bearer ${token.access_token}`
        }
      })
      if (result.status === 201) {
        JalaAnalytic.log('Mobile app: activity - status - changed');

        this.set('error', null)
      } else {
        this.set('error', getGeneralApiProblem(result))
      }
      this.set('loading', false);
      return result
    },

    async onRefresh() {
      const { appStore } = self.rootStore
      if (appStore.farmStore) {
        this.set('refreshing', true)
        appStore.farmStore.getCycleToDos(true, () => {
          this.set('refreshing', false)
        })
      }
    },

    setHiddenParameter(parameter, pondId, date) {
      let array = self.hiddenParameter
      const data = { date, pondId: pondId, parameter: [ parameter ] }

      const index = array.findIndex((obj) => obj.pondId === pondId && obj.date === date)
      if (index > -1) {
        let existingData = array[index]
        let existingParameter = existingData.parameter
        const existingParameterIndex = existingData.parameter.indexOf(parameter)
        if (existingParameterIndex > -1) existingParameter = existingData.parameter.filter((param) => param !== parameter)
        else existingParameter = [ ...existingParameter, parameter ]
        existingData = { ...existingData, parameter: existingParameter }
        array[index] = existingData
      } else array = cast([ ...array, data ])
      this.set('hiddenParameter', array)
    },

    setHiddenState(parameter, pondId, date) {
      let array = self.hiddenState
      const data = { date, pondId: pondId, parameter: [ parameter ] }
      const index = array.findIndex((obj) => obj.pondId === pondId && obj.date === date)
      if (index > -1) {
        let existingData = array[index]
        let existingKey = existingData.parameter
        const existingParameterIndex = existingData.parameter.indexOf(parameter)
        if (existingParameterIndex > -1) existingKey = existingData.parameter.filter((param) => param !== parameter)
        else existingKey = [ ...existingKey, parameter ]
        existingData = { ...existingData, parameter: existingKey }
        array[index] = existingData
      } else array = cast([ ...array, data ])
      this.set('hiddenState', array)
    }
  })) // eslint-disable-line @typescript-eslint/no-unused-vars

type ActivityStoreType = Instance<typeof CycleToDoStoreModel>
export interface ActivityStore extends ActivityStoreType {}
type ActivityStoreSnapshotType = SnapshotOut<typeof CycleToDoStoreModel>
export interface ActivityStoreSnapshot extends ActivityStoreSnapshotType {}
export const createActivityStoreDefaultModel = () => types.optional(CycleToDoStoreModel, {})
